import React from 'react';
import moment from 'moment';
import _ from 'lodash';

import { getBorrowerLoan } from './../../action/BorrowerAction';
import { getList as getLoanStatusList } from './../../action/_LoanStatusAction';

import constant from '../../constant';
import Shimmer from '../../component/common/Shimmer';
import { checkVersion, downloadFileWithName, dynamicSort } from '../../utils';
import UploadDocumentButton from '../../component/document/UploadDocumentButton';
// import { CustomChatButton } from '../../component/chat/ChatButton';
import SideBar from '../../component/common/Sidebar';

class ComponentName extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            openLoanList: undefined,
            activeLoanStatusId: undefined,
            activeLoanId: '',
            unreadMessageCount: []
        }
    }

    componentDidMount() {
        document.title = constant.component.loanList.title;
        getLoanStatusList().then((res: any) => {
            this.setState({ loanStatusList: res.result }, () => {
                this.onLoadOpenLoan();
            });
        });
        this.onBindSocketEvents();
        checkVersion();
    }


    render() {
        const { openLoanList, activeLoanId, unreadMessageCount } = this.state;
        const { socket } = this.props;
        return (
            <React.Fragment>
                <div className="container-fluid my-3">
                    <SideBar loanList={openLoanList} activeLoanId={activeLoanId} onChangeActiveLoanId={this.onChangeActiveLoanId} unreadMessageCountList={unreadMessageCount} socket={socket} />
                    <div className="main">
                        {
                            this.renderOpenLoans()
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderOpenLoans = () => {
        const { openLoanList, activeLoanId } = this.state;
        return (
            <React.Fragment>
                {
                    openLoanList
                        ? openLoanList.map((item: any, index: number) => {
                            if (item.loanId !== activeLoanId) {
                                return null;
                            }
                            return <div className="row mb-5" key={index}>
                                <div className="col-md-12">
                                    {this.renderLoanDetail(item)}
                                </div>
                            </div>
                        })
                        : <div className="card">
                            <div className="card-body">
                                <Shimmer />
                            </div>
                        </div>
                }
            </React.Fragment>
        )
    }

    renderLoanDetail = (item: any) => {
        const memberList = item.loanMember;
        const loaList = memberList.filter((i: any) => i.isLOHelper === true);
        const processorList = memberList.filter((i: any) => i.isProcessor === true);
        // const unreadMessageCount = item.borrowerMessageList.filter((i: any) => i.readByCustomer === false).length;

        return (
            <>
                <div className="b-shadow border-eee p-3 bg-white br-3">
                    <div className="row mb-5">
                        <div className="col-md-12 text-right mb-3">
                            {
                                item.onHold && <span className="badge badge-danger mr-3">
                                    Loan On Hold</span>
                            }
                            {
                                item.isSuspended && <span className="badge badge-danger mr-3">Loan is Suspended</span>
                            }
                            {
                                item.isSubmissionOnHold && <span className="badge badge-danger mr-3">Loan Submission is on Hold</span>
                            }
                        </div>
                        <div className="col-md-3">
                            <small>Loan ID<span className="text-white">
                                {item.id}
                            </span></small>
                            <div className="color-primary" style={{ fontWeight: 'bold' }}>
                                {item.loanId}&nbsp;
                            </div>
                        </div>
                        <div className="col-md-3">
                            <small>Loan Status</small>
                            <div className="">{item.statusName}</div>
                        </div>
                        <div className="col-md-3">
                            <small>Application Date</small>
                            <div className="">
                                {/* <TimeSpanWithTimer dateTime={item.registeredWithBankOn} /> */}
                                {item.registeredWithBankOn ? moment(item.registeredWithBankOn).format(constant.formatting.usDateWithDayFormat) : '-'}
                            </div>
                        </div>
                        <div className="col-md-3">
                            <small>Last Modified On</small>
                            <div className="">
                                {moment(item.modifiedOn).format(constant.formatting.usDateTimeFormat)}
                                {/* <TimeSpanWithTimer dateTime={item.modifiedOn} /> */}
                            </div>
                        </div>
                        {/* <div style={{ position: 'absolute', right: '2rem', top: '1rem' }}>
                        <div className="d-inline-block">
                            <CustomChatButton css={unreadMessageCount > 0 ? "blink btn btn-danger" : "btn btn-primary"} id={item.id}>
                                View Message {unreadMessageCount > 0 && <span className="badge badge-light ml-2">{unreadMessageCount}</span>}
                            </CustomChatButton>
                        </div>
                    </div> */}
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="">
                                <small>
                                    Progress
                                </small>
                                {this.renderProgress(item)}
                            </div>
                        </div>
                    </div>

                </div >

                <div className="row mt-3">
                    <div className="col-md-4 mb-3">
                        <div className="alert alert-warning br-3 b-shadow" style={{ height: '100%', display: 'flex', justifyContent: 'space-around', flexDirection: 'column' }}>
                            {
                                loaList.length > 0 && <div className="mb-3">
                                    {loaList[0].name} (Loan Originator)
                                    <div className="row">
                                        <div className="col">
                                            <span className="mr-2 text-dark">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-1">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                                                </svg>
                                            </span>
                                            <a href={`mailto:${loaList[0].email}`}>
                                                {loaList[0].email}
                                            </a>
                                        </div>
                                        <div className="col">
                                            <span className="mr-2 text-dark">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-1">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                                </svg>
                                            </span>
                                            <a href={`tel:${loaList[0].mobile}`}>
                                                {loaList[0].mobile}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            }


                            {
                                processorList.length > 0 && <div className="mb-3">
                                    {processorList[0].name} (Loan Processor)
                                    <div className="row">
                                        <div className="col">
                                            <span className="mr-2 text-dark">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-1">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                                                </svg>
                                            </span>
                                            <a href={`mailto:${processorList[0].email}`}>
                                                {processorList[0].email}
                                            </a>
                                        </div>
                                        <div className="col">
                                            <span className="mr-2 text-dark">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-1">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                                </svg>
                                            </span>
                                            <a href={`tel:${processorList[0].mobile}`}>
                                                {processorList[0].mobile}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="col-md-4 mb-3">
                        <div className="alert alert-primary br-3 b-shadow" style={{ height: '100%', display: 'flex', justifyContent: 'space-around', flexDirection: 'column' }}>
                            <div className="row">
                                <div className="col-md-6">
                                    <small>Borrower Name</small>
                                    <div className="">
                                        {item.borrowerName}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <small>Borrower Email</small>
                                    <div className="">
                                        {item.borrowerEmail}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <small>Home Phone</small>
                                    <div className="">
                                        {item.borrowerHomePhone ? item.borrowerHomePhone : '-'}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <small>Business Phone</small>
                                    <div className="">
                                        {item.borrowerBusinessPhone ? item.borrowerBusinessPhone : '-'}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <small>Cell Phone</small>
                                    <div className="">
                                        {item.borrowerCellPhone ? item.borrowerCellPhone : '-'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 mb-3">

                        <div className="alert alert-primary br-3 b-shadow" style={{ height: '100%', display: 'flex', justifyContent: 'space-around', flexDirection: 'column' }}>
                            <div className="row">
                                <div className="col-md-8">
                                    <small>Lender</small>
                                    <div className="">
                                        {item.lenderName ? item.lenderName : '-'}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <small>Loan Amount</small>
                                    <div className="">
                                        {item.loanAmount ? `$${parseFloat(item.loanAmount).toLocaleString()}` : '-'}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <small>Address</small>
                                    <div>
                                        <a className="mr-2" target="_blank" rel="noreferrer" href={`https://maps.google.com/?q=${item.subjectPropertyStreet} ${item.subjectPropertyCity} ${item.subjectPropertyState} ${item.subjectPropertyZipCode} USA`}>
                                            <span className="mr-2">
                                                {item.subjectPropertyStreet}
                                            </span>
                                            <span className="mr-2">
                                                {item.subjectPropertyCity}
                                            </span>
                                            <span className="mr-2">
                                                {item.subjectPropertyState}
                                            </span>
                                            <span className="mr-2">
                                                {item.subjectPropertyZipCode}
                                            </span>
                                            <span className="">
                                                USA
                                            </span>
                                        </a>
                                    </div>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <small>Note Rate</small>
                                    <div className="">
                                        {item.noteRate ? item.noteRate : '-'}%
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <small>Note Rate Expiry</small>
                                    <div className="">
                                        {item.noteRateExpiry ? item.noteRateExpiry : '-'}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <small>Loan Purpose</small>
                                    <div className="">
                                        {item.loanPurpose ? item.loanPurpose : '-'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="row mt-3">
                    <div className="col-md-3 mb-3">
                        <div className="b-shadow border-eee p-3 br-3 bg-white">
                            <div className="mb-3 color-secondary">Title Company</div>
                            <div>
                                {item.titleCompanyName ? item.titleCompanyName : <div className="text-center text-info">Title Company Not Assigned</div>}
                                {/* {item.titleCompanyStatusName} */}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <div className="b-shadow border-eee p-3 br-3 bg-white">
                            <div className="mb-3 color-secondary">Closing Agent</div>
                            <div>
                                {item.closingAgentName ? item.closingAgentName : <div className="text-center text-info">Closing Agent Not Assigned</div>}
                                {/* {item.closingAgentStatusName} */}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <div className="b-shadow border-eee p-3 br-3 bg-white">
                            <div className="mb-3 color-secondary">Appraiser</div>
                            <div>
                                {item.appraiserName ? item.appraiserName : <div className="text-center text-info">Appraiser Not Assigned</div>}
                                {/* {item.appraiserStatusName} */}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <div className="b-shadow border-eee p-3 br-3 bg-white">
                            <div className="mb-3 color-secondary">Insurance Company</div>
                            <div>
                                {item.insuranceCompanyName ? item.insuranceCompanyName : <div className="text-center text-info">Insurance Company Not Assigned</div>}
                                {/* {item.insuranceCompanyStatusName} */}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-6 mb-3">
                        <div className="b-shadow border-eee p-3 br-3 bg-white" style={{ height: '100%' }}>
                            <div className="mb-3 color-secondary">Capital Plus Document</div>
                            <div className="row mt-3">
                                {
                                    item.documentList.map((doc: any, index: number) => {
                                        const url = `${process.env.REACT_APP_AWS_BUCKET_URL}/document/${doc.loanDetailId}/${doc.fileName}`;
                                        const createdOn = moment(doc.createdOn).format(constant.formatting.usDateTimeFormat);
                                        return <div className="col-md-3 mb-3" key={index}>
                                            <button className="d-block btn btn-link p-0  text-left" onClick={() => downloadFileWithName(url, doc.originalFileName)}>{doc.documentName}</button>
                                            <small>{createdOn}</small>
                                        </div>
                                    })
                                }
                                {
                                    item.documentList.length === 0 && <div className="col-md-12 text-center text-info">
                                        No Documents Found
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="b-shadow border-eee p-3 br-3 bg-white" style={{ height: '100%' }}>
                            <div className="row mb-3">
                                <div className="col">
                                    <div className="color-secondary">Document Uploaded</div>
                                </div>
                                <div className="col-auto">
                                    <UploadDocumentButton css="btn btn-link p-0" loanDetail={item} onSubmitComplete={this.onLoadAllLoans}>
                                        + Upload Document
                                    </UploadDocumentButton>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-12">
                                    <div className="row">
                                        {
                                            item.borrowerDocumentList.map((doc: any, index: number) => {
                                                const url = `${process.env.REACT_APP_AWS_BUCKET_URL}/borrower-document/${doc.loanDetailId}/${doc.fileName}`;
                                                const createdOn = moment(doc.createdOn).format(constant.formatting.usDateTimeFormat);
                                                return <div className="col-md-3 mb-3" key={index}>
                                                    <button className="mr-2 btn btn-link p-0" onClick={() => downloadFileWithName(url, doc.originalFileName)}>{doc.originalFileName}</button>
                                                    {
                                                        doc.comment ? <span title={doc.comment}>&#9432;</span> : null
                                                    }
                                                    <div>
                                                        <small>{createdOn}</small>
                                                    </div>
                                                </div>
                                            })
                                        }
                                        {
                                            item.borrowerDocumentList.length === 0 && <div className="col-md-12 text-center text-info">
                                                No Documents Found
                                    </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    renderProgress = (loanDetail: any) => {
        const { loanStatusList } = this.state;
        const sortedLoanStatusList = loanDetail.loanStatusTimeline.sort(dynamicSort('position'));
        const lastStatus = sortedLoanStatusList[sortedLoanStatusList.length - 1];

        const remainingStatus = loanStatusList.filter((i: any) => i.position > lastStatus.loanStatusPosition && i.lane === lastStatus.loanStatusLane && i.id !== constant.loanStatus.funded).map((i: any) => {
            return {
                loanStatusName: i.name,
                createdOn: undefined,
                loanStatusId: i.id
            }
        });
        const finalLoanList = [...sortedLoanStatusList, ...remainingStatus];
        const filteredChecklist = loanDetail.loanChecklist.filter((i: any) => i.systemGenerated === false && i.sharedWithClient === true);
        const uniqueLoanStatusId = _.groupBy(filteredChecklist, function (item: any) {
            return item.loanStatusId;
        });
        const uniqueLoanStatusIdList = Object.keys(uniqueLoanStatusId);
        console.log(uniqueLoanStatusIdList)

        return <React.Fragment>
            <div className="">
                <ul className="progress-indicator">
                    {
                        finalLoanList.map((item: any, index: number) => {
                            // const nextItem = finalLoanList[index + 1];
                            // const statusPendingItemList = loanDetail.loanChecklist.filter((i: any) => i.completed === false);
                            const dated = moment(item.createdOn).format(constant.formatting.usDateWithDayFormat);
                            let liCSS = "";
                            if (item.createdOn === undefined) {
                                liCSS = "";
                            } else if (item.createdOn !== undefined) {
                                // if (nextItem && nextItem.createdOn !== undefined) {
                                liCSS = "completed";
                                // } else {
                                //     liCSS = statusPendingItemList.length === 0 ? "completed" : "";
                                // }
                            }
                            else {
                                // liCSS = statusPendingItemList.length === 0 ? "completed" : "";
                            }

                            // const liCSS = true ? "completed" : "";
                            return <li key={index} className={`${liCSS}`}
                            // onClick={() => this.setState({ activeLoanStatusId: item.loanStatusId })}
                            >
                                <span className="bubble pe-none"></span>
                                {item.loanStatusName}<br />
                                <small className="pe-none">{item.createdOn ? dated : ''}</small>
                            </li>
                        })
                    }
                </ul>
                <div className="py-3">
                    {
                        uniqueLoanStatusIdList.map((item: any, index: number) => {
                            const loanStatusId = parseFloat(item);
                            const loanStatusObj = loanStatusList.find((i: any) => loanStatusId === i.id);
                            return (
                                <>
                                    <b>{loanStatusObj.name}</b><br />
                                    {
                                        filteredChecklist.filter((i: any) => i.loanStatusId === loanStatusId).map((item: any) => {
                                            const crOn = moment(item.createdOn).format(constant.formatting.usDateTimeFormat);
                                            const coOn = moment(item.completedOn).format(constant.formatting.usDateTimeFormat);

                                            return <div className="mb-3">
                                                <div>{item.content}</div>
                                                <small className="mr-3">Created On: {crOn}</small>
                                                <small className="mr-3">Completed On: {item.completed ? coOn : '-'}</small>
                                            </div>
                                        })
                                    }
                                </>
                            )
                        })
                    }

                    {
                        filteredChecklist.length === 0 && <div className="text-info">
                            Couldn't find any notes shared with you
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    }

    onChangeActiveLoanId = (loanId: string) => {
        this.setState({ activeLoanId: loanId });
    }

    // load all loans
    onLoadAllLoans = () => {
        this.onLoadOpenLoan();
        // this.onLoadPendingLoan();
        // this.onLoadClosedLoan();
        // this.onLoadDeniedLoan();
    }

    // on load loan
    onLoadOpenLoan = () => {
        this.setState({ openLoanList: undefined });

        getBorrowerLoan().then((res: any) => {
            const { list } = res.result;
            const activeLoanId = list.length > 0 ? list[0].loanId : '';
            this.setState({
                openLoanList: list, activeLoanId
            });
        });
    }

    onBindSocketEvents = () => {
        const { socket } = this.props;
        socket.on("connect", () => {
            socket.emit('get unread message count');
        });

        socket.on("client receive unread message", (res: any) => {
            const filteredList = res.filter((i: any) => i.readByCustomer === false);
            this.setState({ unreadMessageCount: filteredList });
        })

        // socket.on("disconnect", () => {
        //     // console.log(socket.id); // undefined
        // });
    }
    // on load loan


}

export default ComponentName;